import React, { useState } from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TextInput,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * PersonChangePassword - reusable change-password form for personnel.
 * Mirrors the production ChangeDriverPassword / ChangeFleetPass / etc. pages.
 */
const Field = ({ label, value, onChangeText, placeholder }) => (
  <View style={styles.inputWrap}>
    <Text style={styles.label}>{label}</Text>
    <TextInput
      value={value}
      onChangeText={onChangeText}
      placeholder={placeholder}
      placeholderTextColor="#ACACAC"
      secureTextEntry
      style={styles.input}
    />
  </View>
);

const PersonChangePassword = ({ title = "Change Password" }) => {
  const navigation = useAppNavigation();
  const [oldP, setOldP] = useState("");
  const [newP, setNewP] = useState("");
  const [confP, setConfP] = useState("");
  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{title}</Text>
      </View>
      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ padding: 20 }}>
        <Field label="Users Password" value={oldP} onChangeText={setOldP} placeholder="Enter Your Password" />
        <Field label="New Password" value={newP} onChangeText={setNewP} placeholder="Enter New Password" />
        <Field label="Confirm Password" value={confP} onChangeText={setConfP} placeholder="Re-enter Your New Password" />
        <View style={styles.actions}>
          <TouchableOpacity style={styles.cancelBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.cancelText}>Cancel</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.updateBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.updateText}>Update</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default PersonChangePassword;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  inputWrap: { marginBottom: 16 },
  label: { color: AppColors.brown1, fontSize: 13, fontFamily: AppFonts.OverpassMedium, marginBottom: 6 },
  input: {
    borderWidth: 1,
    borderColor: "#ACACAC",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  actions: { flexDirection: "row", marginTop: 10 },
  cancelBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginRight: 8,
  },
  cancelText: { color: AppColors.brown1, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
  updateBtn: {
    flex: 1,
    backgroundColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginLeft: 8,
  },
  updateText: { color: AppColors.white, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
});
